module.exports = __webpack_public_path__ + "static/media/password-purple.c0df8a24.svg";